import React from 'react';
import { useNavigation } from '@react-navigation/native';
import {
  Container,
  TextContainer,
  ContentWrapper,
  Title,
  Description,
  Prices,
  PricePrefix,
  PriceRow,
  Image,
  CategoryName,
  ItemContainer,
  ImageContainer,
  Separator,
  StatusBadge,
  StatusText,
  PlaceholderImage,
  PlaceholderText,
} from './styles';
import { useSelector } from 'react-redux';
import { formatCurrency } from '../../Helpers/currency';
import moment from 'moment';

const Item = ({ item, firstItem }) => {
  const { store } = useSelector(state => state.general);
  const navigation = useNavigation();

  const today = moment().format('dddd').toLowerCase();
  const isAvailableToday = item?.availableDays?.[today];
  const isActive = item?.isActive;
  const isDisabled = !isActive || !isAvailableToday;

  const renderPrice = () => {
    if (!isAvailableToday) {
      return (
        <StatusBadge>
          <StatusText>Indisponível hoje</StatusText>
        </StatusBadge>
      );
    }

    if (!isActive) {
      return (
        <StatusBadge soldOut>
          <StatusText soldOut>Esgotado</StatusText>
        </StatusBadge>
      );
    }

    const hasMultiplePrices = item?.prices?.length > 1;
    const price = item?.prices?.[0]?.value;

    if (!price) return null;

    return (
      <PriceRow>
        {hasMultiplePrices && <PricePrefix>A partir de </PricePrefix>}
        <Prices>{formatCurrency(price, store?.currency)}</Prices>
      </PriceRow>
    );
  };

  return (
    <Container>
      {firstItem && <CategoryName>{item?.category?.name}</CategoryName>}
      <ItemContainer
        disabled={isDisabled}
        activeOpacity={0.7}
        onPress={() => navigation.navigate('Description', { item })}>
        <TextContainer>
          <ContentWrapper>
            <Title>{item?.name}</Title>
            {item?.description && (
              <Description>{item.description}</Description>
            )}
          </ContentWrapper>
          {renderPrice()}
        </TextContainer>
        <ImageContainer>
          {item?.photos?.[0]?.url ? (
            <Image
              source={{
                uri: item.photos[0].thumbnailUrl || item.photos[0].url,
              }}
              resizeMode="cover"
            />
          ) : (
            <PlaceholderImage />
          )}
        </ImageContainer>
      </ItemContainer>
      <Separator />
    </Container>
  );
};

export default Item;
